uniform vec2 uScale;
uniform float uOpacity;
uniform float uFade;
uniform float uDim;
uniform sampler2D uTexture;
uniform float uTextureMix;
uniform float uTextureAspect;
uniform float uImageScale;
uniform float uHasImage;
uniform float uHasColor;
uniform vec3 uPlaceholderColor;
uniform vec3 uPlaceholderBg;

varying vec2 vUv;

// 抗鋸齒邊緣函數：用 fwidth 抓螢幕空間變化率，邊界抹一個像素寬的漸層做 AA
float edge(float value, float threshold) {
    float aw = fwidth(value) * 0.5 + 1e-5;
    return 1.0 - smoothstep(threshold - aw, threshold + aw, value);
}

void main() {
    float baseAlpha = uOpacity * uFade * mix(0.15, 1.0, uDim);
    vec4 finalColor = vec4(0.0);

    if(uHasImage < 0.5) {
        if(uHasColor > 0.5) {
            // 專案指定 color：整片替換為該色
            finalColor = vec4(uPlaceholderBg, baseAlpha);
        } else {
            // 沒有貼圖：繪製背景色，並在上面繪製括號與 X 記號（uPlaceholderColor）
            vec2 pos = (vUv - 0.5) * uScale;
            float s = min(uScale.x, uScale.y);
            float armLen = s * 0.22;
            float thick = s * 0.008;

            float dx = uScale.x * 0.5 - abs(pos.x);
            float dy = uScale.y * 0.5 - abs(pos.y);

            float horiz = edge(dx, armLen) * edge(dy, thick);
            float vert = edge(dx, thick) * edge(dy, armLen);
            float bracket = max(horiz, vert);

            // 中央 X 記號
            vec2 npos = pos / uScale;
            float diag1 = abs(npos.x - npos.y);
            float diag2 = abs(npos.x + npos.y);
            float diagThick = 0.008;
            float xLines = max(edge(diag1, diagThick), edge(diag2, diagThick));
            float xExtent = edge(max(abs(npos.x), abs(npos.y)), 0.33);
            float xMask = xLines * xExtent;

            float shapeMask = max(bracket, xMask);

            // 以 uPlaceholderBg 為底，shapeMask 覆蓋的地方混入 uPlaceholderColor
            vec3 c = mix(uPlaceholderBg, uPlaceholderColor, shapeMask);

            // Alpha 保持整張卡片的 baseAlpha（整張卡片都有背景色）
            finalColor = vec4(c, baseAlpha);
        }
    } else {
        // cover-fit 縮放計算
        float meshAspect = uScale.x / uScale.y;
        vec2 ratio = uTextureAspect > meshAspect ? vec2(meshAspect / uTextureAspect, 1.0) : vec2(1.0, uTextureAspect / meshAspect);

        vec2 texUV = (vUv - 0.5) * ratio / uImageScale + 0.5;

        // 貼圖來源常在最外緣留一圈透明填充像素（RGB 通常是黑但 alpha=0）；
        // 讀出貼圖自己的 alpha 一起乘進最終透明度，取樣點貼到那圈填充像素時
        // 直接變透明、不會把填充色當真的顏色畫出來，比單純把 UV 往內縮一點更準確
        // （縮 UV 只是猜一個安全邊界，這裡才是true root cause：沒尊重來源圖片的 alpha）
        vec4 texSample = texture2D(uTexture, texUV);
        vec3 tex = texSample.rgb;
        float gray = dot(tex, vec3(0.299, 0.587, 0.114));

        // 合併 uTextureMix 與 uDim 的灰階程度：
        // 當 uDim = 0 時全灰；當 uDim = 1 時保留 uTextureMix 控制的色彩比例
        float colorFactor = (1.0 - uTextureMix) * uDim;
        vec3 color = mix(vec3(gray), tex, colorFactor);

        finalColor = vec4(color, baseAlpha * texSample.a);
    }

    gl_FragColor = finalColor;
}